import './poster.scss';
import ImageGenerator from '../image-generator/image-generator';
import React from 'react';
import { Link } from 'react-router-dom';

function Posters ({ data }) {

	return(
		<div className={`poster-container style-${data.postersCount}`}>
			{
				data.items.map((item, index) => (
					<Link className="poster-item" to={`/t/poster/${item.id}`}>
						{/*{item.id}*/}
						<div className="items" key={index}>
							<ImageGenerator src={item?.image} alt={item?.title}/>
							{/*<h4>{item.title}</h4>*/}
						</div>
					</Link>
				))
			}
		</div>
	)
}

export default Posters;